import { Box, Stack, useTheme } from '@mui/material';
import NavigationLayout from '../navigation/navigationLayout';
import HeroLayout from './hero/heroLayout';
import SummaryLayout from './summary/summaryLayout';
import HomeServicesLayout from './services/homeServicesLayout';
import ReachLayout from './reach/reachLayout';
import TestimonialsLayout from './testimonials/testimonialsLayout';
import FooterLayout from '../footer/footerLayout';

const HomeSectionLayout = () => {
    const theme = useTheme();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <NavigationLayout />

                <HeroLayout />

                <SummaryLayout />

                <HomeServicesLayout />

                <ReachLayout />

                <TestimonialsLayout />

                <FooterLayout />
            </Box>
        </>
    );
}

export default HomeSectionLayout;